/**
 * Dalbe Portfolio page (/pages/galeria) — client-side category tag filter
 * over the card grid. No page reload; cards for categories with no matching
 * tag simply stay hidden.
 */

const buttons = Array.from(document.querySelectorAll('.dalbe-portfolio__tag'));
const cards = Array.from(document.querySelectorAll('.dalbe-portfolio__card'));

buttons.forEach((button) => {
  button.addEventListener('click', () => {
    const tag = button.dataset.tag;
    buttons.forEach((b) => b.classList.toggle('is-active', b === button));
    cards.forEach((card) => {
      card.style.display = tag === 'mind' || card.dataset.category === tag ? '' : 'none';
    });
  });
});
